import React from 'react'
import {Global} from '@emotion/react'

import colors from '@app/theme/foundations/colors'

/**
 * These classes should only be used for styling PD content!
 * These classes are not intended to be used in React components!
 * Some PD components have inputs that take HTML content, which is injected on the Composable side,
 * these helper classes are for styling that content.
 *
 * @returns {JSX.Element}
 */
const HelperClasses = () => {
    const classes = []
    Object.entries(colors).map(([key, value]) => {
        classes.push(`.text-${key} {color: ${value};}`)
    })

    return <Global styles={classes.join('\n')} />
}

export {HelperClasses}
